import React, { useState } from 'react';
type Notification = {
  id: string;
  event: string;
  date: string;
  impact: 'high_negative' | 'medium_negative' | 'low_positive' | 'medium_positive' | 'high_positive';
  acknowledgedBy: string | null;
};
const notifications: Notification[] = [{
  id: '1',
  event: 'Financial statement: Revenue declined 35% YoY, negative cash flow',
  date: '2/15/2026',
  impact: 'high_negative',
  acknowledgedBy: null
}, {
  id: '2',
  event: 'C-Suite Change: CFO and VP Sales departed the company',
  date: '11/22/2025',
  impact: 'high_negative',
  acknowledgedBy: null
}, {
  id: '3',
  event: 'DBT increased from 15 to 45 days - payment behavior deteriorating',
  date: '10/15/2025',
  impact: 'high_negative',
  acknowledgedBy: null
}, {
  id: '4',
  event: 'News: Key product launch delayed by 6 months due to development issues',
  date: '8/10/2025',
  impact: 'medium_negative',
  acknowledgedBy: null
}];
function ImpactIndicator({
  impact
}: {
  impact: Notification['impact'];
}) {
  if (impact === 'high_negative') {
    return <div className="flex items-end gap-0.5 justify-center" data-id="element-2369">
        <div className="w-1.5 h-2 bg-red-500 rounded-sm" data-id="element-2370" />
        <div className="w-1.5 h-3.5 bg-red-500 rounded-sm" data-id="element-2371" />
        <div className="w-1.5 h-5 bg-red-500 rounded-sm" data-id="element-2372" />
      </div>;
  }
  if (impact === 'medium_negative') {
    return <div className="flex items-end gap-0.5 justify-center" data-id="element-2373">
        <div className="w-1.5 h-2 bg-red-500 rounded-sm" data-id="element-2374" />
        <div className="w-1.5 h-3.5 bg-red-500 rounded-sm" data-id="element-2375" />
        <div className="w-1.5 h-5 bg-gray-200 rounded-sm" data-id="element-2376" />
      </div>;
  }
  if (impact === 'low_positive') {
    return <div className="flex items-end gap-0.5 justify-center" data-id="element-2377">
        <div className="w-1.5 h-2 bg-green-500 rounded-sm" data-id="element-2378" />
        <div className="w-1.5 h-3.5 bg-gray-200 rounded-sm" data-id="element-2379" />
        <div className="w-1.5 h-5 bg-gray-200 rounded-sm" data-id="element-2380" />
      </div>;
  }
  if (impact === 'medium_positive') {
    return <div className="flex items-end gap-0.5 justify-center" data-id="element-2381">
        <div className="w-1.5 h-2 bg-green-500 rounded-sm" data-id="element-2382" />
        <div className="w-1.5 h-3.5 bg-green-500 rounded-sm" data-id="element-2383" />
        <div className="w-1.5 h-5 bg-gray-200 rounded-sm" data-id="element-2384" />
      </div>;
  }
  // high_positive
  return <div className="flex items-end gap-0.5 justify-center" data-id="element-2385">
      <div className="w-1.5 h-2 bg-green-500 rounded-sm" data-id="element-2386" />
      <div className="w-1.5 h-3.5 bg-green-500 rounded-sm" data-id="element-2387" />
      <div className="w-1.5 h-5 bg-green-500 rounded-sm" data-id="element-2388" />
    </div>;
}
export function InitechNotificationsTab() {
  const [selected, setSelected] = useState<Set<string>>(new Set());
  const toggleAll = () => {
    if (selected.size === notifications.length) {
      setSelected(new Set());
    } else {
      setSelected(new Set(notifications.map(n => n.id)));
    }
  };
  const toggleOne = (id: string) => {
    const next = new Set(selected);
    if (next.has(id)) {
      next.delete(id);
    } else {
      next.add(id);
    }
    setSelected(next);
  };
  return <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-2389">
      <div className="p-5 border-b border-gray-200" data-id="element-2390">
        <h3 className="text-lg font-bold text-gray-900" data-id="element-2391">Notifications</h3>
      </div>
      <div className="overflow-x-auto" data-id="element-2392">
        <table className="w-full text-sm text-left" data-id="element-2393">
          <thead className="bg-gray-50 text-gray-500 border-b border-gray-200" data-id="element-2394">
            <tr data-id="element-2395">
              <th className="px-5 py-3 w-10" data-id="element-2396">
                <input type="checkbox" checked={selected.size === notifications.length} onChange={toggleAll} className="w-4 h-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500 cursor-pointer" data-id="element-2397" />
              </th>
              <th className="px-5 py-3 font-medium" data-id="element-2398">Event</th>
              <th className="px-5 py-3 font-medium text-center w-32" data-id="element-2399">Date</th>
              <th className="px-5 py-3 font-medium text-center w-24" data-id="element-2400">Impact</th>
              <th className="px-5 py-3 font-medium text-center w-40" data-id="element-2401">
                Acknowledged By
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200" data-id="element-2402">
            {notifications.map(n => <tr key={n.id} className="hover:bg-gray-50 transition-colors" data-id="element-2403">
                <td className="px-5 py-4" data-id="element-2404">
                  <input type="checkbox" checked={selected.has(n.id)} onChange={() => toggleOne(n.id)} className="w-4 h-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500 cursor-pointer" data-id="element-2405" />
                </td>
                <td className="px-5 py-4 text-gray-900" data-id="element-2406">{n.event}</td>
                <td className="px-5 py-4 text-gray-500 text-center whitespace-nowrap" data-id="element-2407">
                  {n.date}
                </td>
                <td className="px-5 py-4 text-center" data-id="element-2408">
                  <ImpactIndicator impact={n.impact} data-id="element-2409" />
                </td>
                <td className="px-5 py-4 text-gray-500 text-center" data-id="element-2410">
                  {n.acknowledgedBy ?? '--'}
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
      <div className="flex items-center justify-end gap-4 px-5 py-3 border-t border-gray-200 text-sm text-gray-500" data-id="element-2411">
        <span data-id="element-2412">Rows per page: 5</span>
        <span data-id="element-2413">1–4 of 4</span>
        <div className="flex gap-1" data-id="element-2414">
          <button className="p-1 rounded hover:bg-gray-100 text-gray-400 cursor-not-allowed" data-id="element-2415">
            ‹
          </button>
          <button className="p-1 rounded hover:bg-gray-100 text-gray-400 cursor-not-allowed" data-id="element-2416">
            ›
          </button>
        </div>
      </div>
    </div>;
}